angular.module('leanlaw').controller('ClientContactCtrl', ['$scope', '$rootScope', '$q', '$filter', "alerts", 'userService', 'clientManager', 'matterManager', 'lists', "exportJson", "singleRequest", "messageBus", function ($scope, $rootScope, $q, $filter, alerts, userService, clientManager, matterManager, lists, exportJson, singleRequest, messageBus) {
  $scope.data = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = ['reference', 'name'];
  $scope.reverse = false;
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    const matter = $scope.me.terms.Matter;
    const exp = $scope.data.filteredClients.reduce((accum, c) => {
      const item = {
        "Client ID": c.reference,
        "Client": c.name,
        "Email": c.contact && c.contact.email,
        "Address": c.fullAddress,
        "Country": c.country,
        "Phone": c.contact && c.contact.phone,
        "Other Phones": c.otherPhones
      };
      if ($scope.filter.include && $scope.filter.include.matters) {
        item[matter + 's'] = c.matterNames;
      }
      accum.push(item);
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  activate();

  ///////////////////

  function activate() {
    // Note: even though we are not using 'me' it should still be loaded to ensure that
    // the lists are updated correctly (me() replaces certain terms in lists.matterRoles)
    userService.me().then(me => {
      $scope.me = me;
      $scope.$on('commonFilterService-statechanged', (event, payload) => {
        if (!payload) return;
        // Assigning to existing filter keeps custom filter options
        $scope.filter = Object.assign($scope.filter, payload);
        // Necessary to set this value for the requests
        $scope.filter.status = $scope.filter.archived.status;
        $scope.filter.scope = $scope.filter.filter.scope;
        filterClientEntries();
      });
      $scope.$on("report-sidebar-filterchange", (event, payload) => {
        $scope.filter = Object.assign($scope.filter, payload);
      });

      // MessageBus is used here so that the commonFilter module can pick it up once it loads
      messageBus.addMessage("filterDependency-ready", true);
    });
  }
  function filterClientEntries() {
    let filter = $scope.filter;
    $scope.loading = true;
    var query = {
      scope: 'all',
      contact: 'include',
      status: filter.status
    };
    if (filter.filter.scope) {
      query.scope = filter.filter.scope;
      if (filter.filter.scopeAccount) {
        query.scopeAccount = filter.filter.scopeAccount.id;
      }
    }
    // This is sort of weird. We are getting matters from matterManager because the clientManager lists
    // all clients regardless of the 'status' (archived/active) attribute. So we go through and find all
    // matters that match the query, then return the clients for those matters. We have to use the
    // clientManager for the clients because the clients contained in matters do not include contact
    // information. Perhaps a better way is to have the clientMatterManager return the correct stuff
    // in the first place?
    clientManager.list(query).then(clientsWithAddress => {
      return matterManager.list(query).then(matters => {
        var mattersGroupedByClient = _.groupBy(matters, m => m.client.id);
        var clients = Object.keys(mattersGroupedByClient).map(id => {
          // get a copy of the client so we can replace the matters list
          // with our modified matters list
          var clientFromList = clientsWithAddress.find(c => c.id === id);
          var clientFromMatter = mattersGroupedByClient[id]?.[0]?.client;

          // Use client from list if available, otherwise fall back to client from matter
          // If a client has only archived matters, it won't show up in clientFromList
          var clientData = clientFromList || clientFromMatter;
          return Object.assign({}, clientData, {
            matters: mattersGroupedByClient[id]
          });
        });
        clients.forEach(process);
        $scope.showReferences = !!clients.find(c => c.reference);
        $scope.showCountryColumn = !!clients.find(c => c.country);
        $scope.data.clients = clients;
        $scope.loading = false;
      });
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  }
  function process(c) {
    c.matterNames = c.matters && c.matters.map(m => m.label).join(', ') || '';
    c.fullAddress = '';
    c.country = '';
    c.otherPhones = '';
    if (c.contact && c.contact.address) {
      // Build address
      const addressParts = [];

      // Street address (first line)
      if (c.contact.address.address) {
        addressParts.push(c.contact.address.address);
      }

      // City, State ZIP (second line)
      let cityStateZip = '';
      if (c.contact.address.city) {
        cityStateZip = c.contact.address.city;
      }
      if (c.contact.address.state) {
        if (cityStateZip) cityStateZip += ', ';
        cityStateZip += c.contact.address.state;
      }
      if (c.contact.address.zip) {
        if (cityStateZip) cityStateZip += ' ';
        cityStateZip += c.contact.address.zip;
      }
      if (cityStateZip) {
        addressParts.push(cityStateZip);
      }
      c.fullAddress = addressParts.join('\n');
    }

    // Always set country field for consistent sorting
    c.country = c.contact && c.contact.address && c.contact.address.country || '';

    // Phone processing
    if (c.contact) {
      c.otherPhones = [c.contact.cell, c.contact.fax, c.contact.other].filter(Boolean).join('\n');
    }
  }

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filteredClients = $filter('orderBy')($filter('filter')($scope.data.clients, $scope.search), $scope.sort, $scope.reverse) || [];
  }
  $scope.$watch('data.clients', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);